const FeedxmlIconBranco = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.1"
      id="Camada_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 3000 3000"
	  {...props}
	  width={22} height={22}
    >
      <g>
        <path
          className="feedbrancosdjff"
          d="M2899.7,1109.6c-4.3-57.7-38.4-92.3-87-125.9c-91.4-63.2-193.3-100.5-304.2-110.9
		c-61-5.8-163.3,11.6-221.3,29.6c-11,3.4-11,3.4-16.9-2.3l-37.6-39.5c-1.7-2.4-0.8-5.1,0.8-7.5c10.9-16.4,18.3-29.5,37.4-42.9
		c33.3-23.3,84.3-18.4,115.8,4.5c35.6,25.9,75.7,33.9,118.7,29.6c54-5.3,82.1-38.2,74.8-88c-7.1-47.7-28.8-87.5-66.3-118.4
		c-46.7-38.4-101.5-59.8-158.7-75.9c-81.5-23-155.9-8.4-224.2,41.4c-35.7,26.1-97.4,80.4-128.8,111.2c-8.8,8.7-11.8,4.1-23.7,0.3
		c-155.7-50.8-337.4-66.8-499.7-47.6c-254.1,29.9-488.5,122.2-682.3,293.2c-7.8,4.8-10.6,5.2-21.1,0.9
		c-31.6-12.6-63.3-25.1-95.5-36.1c-58-19.9-118.1-36.6-178.4-18.2c-106.9,32.5-181.4,105.2-227.9,205.4c-17.8,38.4-43,99-15.8,131.8
		c25.6,30.9,57.1,43.1,97.8,35.2c48.9-9.5,87-34.1,113.6-76.5c15.2-24.2,35.1-44.2,65.5-42.3c30,1.9,60,6.9,89.5,17.6
		c2.5,0.8,3.7,3.7,2.6,6c-5.3,12.3-13.8,31.9-17.4,44.1c-3.3,10.3-7,12.7-15.5,13.5c-30.8,2.8-69.4,14-99.8,20.6
		c-143.3,31.2-244.8,122.4-332.7,232.7c-34.2,42.9-67.9,96.5-60.2,151.4c4.9,34.7,27.5,67.8,63.8,85.3c38.4,18.6,72.4,0.5,103.9-21
		c31.5-21.6,58.2-48.8,84-76.8c60.7-65.7,141.9-106.9,235-105.3c10.9,0.3,12.3,2.6,13.8,8.1c2.1,7.3,3.4,13.5,5.3,20.6
		c2.6,9.9,1.6,9.7-4.7,13.8c-16.7,10.6-41.9,26.1-54.2,42c-55.5,71-89.7,151.3-98.6,240.9c-8.2,83.5,9,164.9,25.7,246.1
		c9.5,46.3,23.2,91.3,53.3,129c30.8,38.7,80,57.4,124,45.6c39.5-10.7,51.7-52.6,57.8-96.1c3.7-26.1,1.3-51.8-3.8-77.1
		c-9.7-48.5-18.4-96.9-15.6-146.7c3.6-63,27.4-119.2,82.1-156.3c10.8-7.3,11-9.4,22.5-0.7c18.6,14.2,57.8,37.2,78,49.3
		c20.5,12.4,22.7,16.9,12.8,36.8c-78.7,157.6-45.6,408,111.2,528.7c40.1,30.8,84.5,40.3,133,33.8c28.6-3.8,48.8-20.6,57.8-48.5
		c14.1-43.5,2.5-82.1-23.7-117.8c-74.7-101.9-82.1-214.8-24-328.4c7.5-14.8,9.4-13.6,25.8-10.8c151.3,25.8,303.9,18.1,453.3-12.9
		c147.1-30.6,290.6-86.1,417.7-167.5c7.8-5.1,10.3-5,17-0.2c101.9,72.9,142.4,210.6,113.4,307.9c-6.4,21.4-7.7,43.5-5.8,65.5
		c4.9,55.5,52.2,95.7,100,83.6c44.2-11.3,80.2-35.2,104.7-75c85.8-139.1,71.6-348.6-32.5-475.1c-22.9-27.8-55.3-55.5-82.9-78.2
		c-5.1-4.1-5.5-6,1.8-15.1c22.5-27.8,48.5-61.6,66.2-92.7c4.1-7.2,4.7-6.3,12.1-3c40.6,18.4,86,32.3,114.1,68.8
		c34,44,51.8,88.8,63.4,142.7c8.7,40,15.2,80.4,35.7,116.8c19.3,34.2,80.4,62.7,119.7,52.6c46.5-11.9,56.1-25.2,70.9-73.3
		c8.5-27.6,6.9-56.9,4.1-86.1c-4.5-47.1-15.3-92.8-25.6-138.6c-23.1-102.7-62.9-196.5-143.5-268.3c-43.3-38.5-96.2-79.9-156.8-84.9
		c-9.1-0.8-9.6-2.2-9.5-5.8c0.4-16.3-12-61.7-13.8-68.9c-1.5-5.9,0.7-7.1,8.5-7.6c54.6-4,72.6-14.6,127.9-3.3
		c43.4,8.9,126.8,40.1,167.2,57.4c37,15.9,75.2,29.5,116,29.3C2864,1209.1,2903.9,1163.5,2899.7,1109.6z M1677.7,1607.8
		c-6.1,61.1-52,100.2-126.3,100c-32.1-2.6-68.4-14.2-90.4-53c-12.4-21.8-9.8-41.3,7-52.5c16.8-11.1,37.4-6.7,50.4,14.6
		c14.1,23.4,51,28.9,76.4,11.3c9.8-6.8,13.2-17.1,14.7-29.3c3.3-27.1,20.2-41.7,41.4-38.5C1671,1563.5,1680.5,1580.2,1677.7,1607.8z
		 M2216.1,1389.8c-9.8,46.1-35.7,84.5-73.8,111.9c-84.9,61.1-180.9,90.4-285.3,92.9c-10.2,0.7-21.4,0.4-31.1-0.3l0,0
		c-0.5,0-1-0.1-1.5-0.2c-0.1,0-0.1,0-0.2,0l0,0c-70.6-7-122.9-50.4-170.3-102.5c-22.9-25.4-41.1-54.4-57.1-84.7
		c-11.3-21.4-23.7-42.3-40.1-60.5c-11.5-12.7-24.5-19.9-42-17.2c-6.1,0.4-11.4,1.7-15.9,3.8c-12.8,5.8-20.2,17.7-25.3,32.5
		c-2.4,7.1-4.3,14.1-5.8,21.3c-6.5,29.9-6.8,60.7-12.4,90.7c-4.9,26.2-12,51.6-20.7,76.7c-29.3,84.4-84,136-157.8,163.2
		c-23.6,8.7-49,14.9-76.3,18.9c-41.3,6-82.7,12.1-124.7,8.6c-19-0.2-37.2-1.7-54.5-4.8l0,0c-62.9-11.1-115-42.5-153-103.4
		c-58.4-93.6-103-192.3-122.8-301.3c-9.1-49.7,7.5-85.8,51.9-110.7c57.3-32.1,121-47.8,183.5-65.6c104-29.6,209.4-52,318.4-47.4
		c27,1.1,53.9,4.6,80.7,7.3l0,0c2.5,0.3,4.9,0.6,7.5,0.8c79.5,10.6,146.3-23.9,211.3-61.8c21.8-12.6,49.5-24.4,79-34.8l0,0
		c49.4-17.4,104.1-31.2,144.9-39.3c84-16.8,169-26.4,254.5-30.6c32.3-1.6,65.2-1.5,94.4,16.4c4,2.2,7.6,4.4,10.8,7.2
		c23.5,18.2,32.9,45.5,38.4,73.5C2243.4,1163.7,2240.2,1277.1,2216.1,1389.8z"
        />
      </g>
    </svg>
  );
};

export default FeedxmlIconBranco;
